import React from 'react';
import Loading from '../../loadings';
import Server from '../../../functions/server';
import $ from "jquery";

class Inwards extends React.Component {

  state = {
    from_date: this.props.fromDate,
    to_date: this.props.toDate, credit: []
  }


  getDetails() {
    if (this.state.from_date == null || this.state.from_date == undefined || this.state.from_date == '' ||
        this.state.to_date == null || this.state.to_date == undefined || this.state.to_date == '') {
      this.setState({ openDateDialog: true });
      return;
    }
    else {
      this.getCreditNotes(this.state.from_date, this.state.to_date);
    }
  }

  getCreditNotes(from_date, to_date) {
    let context = this;
    context.setState({ load: true, message: 'Getting Sales', openDateDialog: false })
    $.ajax({
        type: 'POST',
        data: { 'partno': context.props.partno, 'brand': context.props.brand,
                'branch': context.props.branch, 'fromdate': from_date,
                'todate': to_date },
        url: Server() + 'stockinfo/links/credit.php',
        success: function(data) {
          console.log(data);
          context.setState({ load: false })
          try {
            data = JSON.parse(data);
            context.setState({ credit: data, open: true })
          } catch (e) {
            console.log(e);
          }
        },
        error: function(e)
        {
          alert('Try again!!')
          context.setState({
            load: false
          });
        }
      });
  }


  render() {
    let i = 1;
    return (
      <div>
        <u id='pointer' style={{color: '#276EF8'}}>{this.props.credit}</u>
        <Loading load={this.state.load} message={this.state.message} />
      </div>
    );
  }
}

export default Inwards;
